import React from 'react';
import { DialogContent, DialogTitle } from '@mui/material';
import { RoundedDialog, StandardDialogActions } from '../../Components';
import ColorCheckField from '../ColorCheckField';

export default function ColorCheckDialog({ open, onClose, initial, editable, onChange, config }) {
  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
      <DialogTitle>Colour</DialogTitle>
      <DialogContent>
        <ColorCheckField initial={initial} onChange={onChange} config={config} editable={editable} />
      </DialogContent>
      <StandardDialogActions onClose={onClose} onDone={onClose} hideDone={!editable} />
    </RoundedDialog>
  );
}
